import {createTheme, ThemeProvider, useTheme} from "@mui/material";
import {type ReactNode, useMemo} from "react";

type Props = {
    children: ReactNode;
};

const TableTheme = ({children}: Props) => {
    const globalTheme = useTheme();
    const tableTheme = useMemo(
        () =>
            createTheme({
                ...globalTheme,
                palette: {
                    ...globalTheme.palette,
                    background: {
                        ...globalTheme.palette.background,
                        default: globalTheme.palette.background.paper,
                    },
                },
            }),
        [globalTheme],
    );
    return <ThemeProvider theme={tableTheme}>{children}</ThemeProvider>;
};

export default TableTheme;
